export const SOCKET_CONNECTION_INIT = '@socket/SOCKET_CONNECTION_INIT';
export const SOCKET_CONNECTION_SUCCESS = '@socket/SOCKET_CONNECTION_SUCCESS';
export const SOCKET_CONNECTION_ERROR = '@socket/SOCKET_CONNECTION_ERROR';
export const SOCKET_CONNECTION_CLOSED = '@socket/SOCKET_CONNECTION_CLOSED';